import type { ReactNode } from 'react';
import type { CashReceiptDetail } from '@erp/rpc';
import { T, useGT } from 'gt-react';

interface CashReceiptBankSectionProps {
  receipt: CashReceiptDetail;
}

function BankRow({ label, value }: { label: ReactNode; value: string | null }) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className="text-sm">{value ?? '—'}</span>
    </div>
  );
}

export function CashReceiptBankSection({
  receipt,
}: CashReceiptBankSectionProps) {
  const gt = useGT();
  const { bankTransaction } = receipt;

  return (
    <div className="space-y-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <T context="AR cash receipt, section heading for linked bank transaction">
          Bank Transaction
        </T>
      </p>

      {bankTransaction ? (
        <div className="space-y-2">
          <BankRow
            label={gt('Type', { context: 'bank transaction field label' })}
            value={bankTransaction.type}
          />
          <BankRow
            label={gt('Account', { context: 'bank transaction field label' })}
            value={bankTransaction.accountId}
          />
          <BankRow
            label={gt('Merchant Name', {
              context: 'bank transaction field label',
            })}
            value={bankTransaction.merchantName}
          />
          <BankRow
            label={gt('Description', {
              context: 'bank transaction field label',
            })}
            value={bankTransaction.description}
          />
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">
          <T context="AR cash receipt when no bank transaction is linked">
            No bank data available
          </T>
        </p>
      )}
    </div>
  );
}
